var Backbone = require('backbone/backbone');
var _ = require('underscore/underscore');
require('owl.carousel/dist/assets/owl.carousel.css');
require('owl.carousel');
require('jquery.dotdotdot');
var FontFaceObserver = require('fontfaceobserver');

require('front/components/CommentCount/CommentCount');
require('front/components/Category/Category');
require('front/components/PhotoRecentItem/PhotoRecentItem');
require('./PhotoRecent.less');

var CheckDevice = require('front/utils/CheckDevice/CheckDevice');

module.exports = Backbone.View.extend({
    events: {
        'mouseenter .PhotoRecentItem .PhotoRecentItem-title': 'hoverOn',
        'mouseleave .PhotoRecentItem .PhotoRecentItem-title': 'hoverOff'
    },

    initialize: function (options) {
        this.type = this.$el.data('type');

        this.initSlider();
        this.initTitles();
    },

    initSlider: function () {
        this.$list = this.$('.PhotoRecent-list');

        this.$list.addClass('PhotoRecent-list--' + this.type);

        var items;
        var margin;

        if (this.type === 'default') {
            items = 4;
            margin = 36;
        } else if (this.type === 'category') {
            items = 2;
            margin = 28;
        }

        // TODO: Учитывать кейс когда айтемов меньше 4
        this.$list.owlCarousel({
            items: items,
            margin: margin,
            mouseDrag: false,
            loop: true,
            nav: true,
            dots: false,
            slideBy: 'page',
            autoplay: false,
            dragEndSpeed: 800
        });
    },

    initTitles: function () {
        var fontRaleway = new FontFaceObserver('Raleway', {
            weight: 800
        });

        var fontOpenSans = new FontFaceObserver('Open Sans', {
            weight: 400
        });

        Promise.all([fontRaleway.load(), fontOpenSans.load()]).then(function () {
            this.$('.PhotoRecentItem-title').dotdotdot();
        }.bind(this));
    },

    hoverOn: function (e) {
        var $item = $(e.target).closest('.PhotoRecentItem');
        $item.addClass('PhotoRecentItem--hover');
    },

    hoverOff: function (e) {
        var $item = $(e.target).closest('.PhotoRecentItem');
        $item.removeClass('PhotoRecentItem--hover');
    }
});




//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/PhotoRecent/PhotoRecent.js
// module id = 175
// module chunks = 0